import { render } from "./WallContour.vue?vue&type=template&id=684784ac"
import script from "./WallContour.vue?vue&type=script&lang=js"
export * from "./WallContour.vue?vue&type=script&lang=js"

import "./WallContour.vue?vue&type=style&index=0&id=684784ac&lang=scss"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__